import { gql, useQuery } from '@apollo/client';

export const LINK_TRUCK_MANUAL = gql`
  query LinkTruck($userId: String!, $truckId: String!, $date: String!) {
    linkTruck(userId: $userId, truckId: $truckId, date: $date)
  }
`;

export function useLinkTruckManual() {
  const { data, loading, error, refetch } = useQuery(LINK_TRUCK_MANUAL, {
    skip: true,
  });

  return { data, loading, error, refetch };
}
